import { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { registerLocale } from "react-datepicker";
import ru from 'date-fns/locale/ru';
import "react-datepicker/dist/react-datepicker.css";
import { useSelector, useDispatch } from 'react-redux';
import axiosInstance from '../../utils/axiosInstanse';
import { clearNotification } from '../../reduser/notificationSlice';
import SubstitutionArchive from './SubstitutionArchive';
import { motion } from 'framer-motion';
import Button from '../CustomButton/Button';
import host from "../../host";
import CustomInput from './CustomPickDate';
import Spiner from '../Spiner/Spiner';
import useIsMobile from '../../utils/useIsMobile';
import { showNotification } from '../../utils/notificationUtils';
import './style.css';
import { setDate } from 'date-fns';

registerLocale('ru', ru);

function MyComponent() {
  const [sub_tab, setSub_tab] = useState('');
  const [startDate, setStartDate] = useState(new Date());
  const [date, setdate] = useState(new Date());
  const [errors, setErrors] = useState({});
  const [sending, setSending] = useState(false);
  const [page, setPage] = useState(1);
  const username = useSelector(state => state.user.username);
  const dispatch = useDispatch();
  const notification = useSelector(state => state.notification);
  const isMobile = useIsMobile(768);
  const [isError, setIsError] = useState(undefined);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axiosInstance.get(`${host}api/get_substitution/`)
      .then(response => {
        setIsLoading(false);
      })
      .catch(error => {
        if (error.response?.status === 403) {
          setIsError(true);
        }
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    if (notification.show) {
      const now = Date.now();
      const elapsedTime = now - notification.startTime;
      const remainingTime = 4000 - elapsedTime;
      if (remainingTime > 0) {
        const timer = setTimeout(() => {
          dispatch(clearNotification());
        }, remainingTime);
        return () => clearTimeout(timer);
      } else {
        dispatch(clearNotification());
      }
    }
  }, [notification, dispatch]);

  const formatDate = (data) => {
    const date = new Date(data);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (sending) return;
    if (validateForm()) {
      const data = {
        date_from: formatDate(startDate),
        date_until: formatDate(date),
        sub_tab: sub_tab,
      };
      setSending(true);
      try {
        const response = await axiosInstance.post(`${host}api/add_substitution/`, data);
        if (response.status === 201) {
          setSending(false);
          setPage(2)
          setSub_tab('')
          setDate(new Date())
          setStartDate(new Date())
          showNotification(dispatch, 'Запись добавлена!', 'success');
        }
      } catch (err) {
        setSending(false);
        if (err.response?.status === 404) {
          showNotification(dispatch, 'Неверный табельный номер', 'error');
        } else if (err.response?.status === 400) {
          showNotification(dispatch, 'Ошибка валидации', 'error');
        } else {
          showNotification(dispatch, 'Ошибка отправки формы', 'error');
        }
      }
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!startDate) newErrors.startDate = 'Дата начала обязательна';
    if (!date) newErrors.date = 'Дата окончания обязательна';
    if (!sub_tab) {
      newErrors.sub_tab = 'Введите табельный номер';
    } else if (sub_tab.length !== 5) {
      newErrors.sub_tab = 'Табельный номер должен содержать 5 цифр';
    } else if (!/^\d+$/.test(sub_tab)) {
      newErrors.sub_tab = 'Табельный номер должен содержать только цифры';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <div className="sub-container">
      <motion.div
        initial={{ opacity: 0, y: -16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.12 }}
      >
        {isLoading ? (
          <Spiner />
        ) : isError ? (
          <div className="sub-access-denied">У вас нет прав для доступа к данному разделу</div>
        ) : (
          <div>
            {/* Tabs */}
            <div className="sub-tabs">
              <button
                className={`sub-tab ${page === 1 ? 'sub-tab--active' : ''}`}
                onClick={() => setPage(1)}
              >
                Новая заявка
              </button>
              <button
                className={`sub-tab ${page === 2 ? 'sub-tab--active' : ''}`}
                onClick={() => setPage(2)}
              >
                Архив
              </button>
            </div>

            {page === 1 ? (
              <div className="sub-card">
                <div className="sub-card-body">
                  <div className="sub-warning">
                    <div className="sub-warning-title">ТОЛЬКО ДЛЯ РУКОВОДИТЕЛЕЙ!</div>
                    <div className="sub-warning-text">
                      Для перенаправления увольнительных записок на другого пользователя необходимо указать дату начала и дату окончания периода, а также табельный номер пользователя, на которого будет оформлено перенаправление.
                    </div>
                  </div>

                  <div className="sub-current-user">Табельный номер: {username}</div>

                  <form onSubmit={handleSubmit}>
                    <div className="sub-date-row">
                      <div className="sub-field">
                        <label className="sub-label">Дата начала:</label>
                        <DatePicker
                          locale="ru"
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          dateFormat="dd.MM.yyyy"
                          popperPlacement="top"
                          customInput={isMobile ? <CustomInput /> : undefined}
                          withPortal
                        />
                      </div>
                      <div className="sub-field">
                        <label className="sub-label">Дата окончания:</label>
                        <DatePicker
                          locale="ru"
                          selected={date}
                          onChange={(date) => setdate(date)}
                          dateFormat="dd.MM.yyyy"
                          popperPlacement="top"
                          customInput={isMobile ? <CustomInput /> : undefined}
                          withPortal
                        />
                      </div>
                    </div>

                    <div className="sub-field">
                      <label className="sub-label" htmlFor="subTabNum">Табельный номер замещающего</label>
                      <textarea
                        id="subTabNum"
                        className={`sub-input ${errors.sub_tab ? 'sub-input--error' : ''}`}
                        placeholder="Введите табельный номер сотрудника, который будет вас замещать"
                        value={sub_tab}
                        onChange={e => setSub_tab(e.target.value)}
                      />
                      {errors.sub_tab && <div className="sub-error">⚠ {errors.sub_tab}</div>}
                    </div>

                    <div className="sub-submit-wrap">
                      {sending ? (
                        <Button type="submit" disabled>
                          <span className="do-spinner" />
                        </Button>
                      ) : (
                        <Button type="submit">Отправить</Button>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            ) : (
              <SubstitutionArchive />
            )}
          </div>
        )}
      </motion.div>
    </div>
  );
}

export default MyComponent;